import { rootApi } from "../../api/rootApi";

export const billingCycleApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    createBillingCycle: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/billing-cycle/add",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
        body: JSON.stringify(params.body),
      }),
    }),

    getAllBillingCycles: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: "/admin/billing-cycle",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
      }),
    }),

    getBillingCycleByTenantId: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/billing-cycle/${params.tenant_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
      }),
    }),

    updateBillingCycle: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/billing-cycle/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
        body: JSON.stringify(params.body),
      }),
    }),

    getBillingStatus: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/billing-cycle/status/${params.tenant_id}`,
        headers: { "Content-Type": "application/json" },
      }),
    }),

    getAllBillingCycleLogs: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: "/admin/billing-cycle/logs",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
      }),
    }),

    getBillingCycleLogsByTenantId: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/billing-cycle/logs/${params.tenant_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
        },
      }),
    }),
  }),
});

export const {
  useCreateBillingCycleMutation,
  useGetAllBillingCyclesMutation,
  useGetBillingCycleByTenantIdMutation,
  useUpdateBillingCycleMutation,
  useGetBillingStatusMutation,
  useGetAllBillingCycleLogsMutation,
  useGetBillingCycleLogsByTenantIdMutation,
} = billingCycleApi;
